import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { siteInfo, reviews } from '@/mocks/data';

export default function AboutPage() {
  const jsonLdOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'http://wiiohv.cn/',
    description: siteInfo.description,
    foundingDate: siteInfo.established,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.email,
      telephone: siteInfo.phone,
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '北京市',
      addressCountry: 'CN',
      streetAddress: '望京科技园A座1208室',
    },
  };

  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrg) }}
      />

      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: '关于我们' },
        ]}
      />

      <section className="bg-background-50 py-10 md:py-16">
        <div className="px-4 md:px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            <div className="w-full lg:w-[55%] flex flex-col justify-center">
              <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
                关于<strong>韩漫大全</strong>
              </h1>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                <strong>韩漫网站</strong>——{siteInfo.description}
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                自 {siteInfo.established} 年成立以来，我们始终以"让每一位中文读者都能免费享受高品质韩国漫画"为使命。通过简洁易记的<strong>韩漫网址</strong>，为读者提供便捷的导航服务。我们的<strong>韩漫大全</strong>合集收录超过 {siteInfo.totalComics} 部作品，涵盖恋爱、奇幻、动作、喜剧、惊悚、日常六大类型。
              </p>

              <div className="flex gap-10 mb-6">
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-foreground-900">{siteInfo.totalComics}</p>
                  <p className="text-xs text-foreground-400 mt-1">收录韩漫</p>
                </div>
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-foreground-900">{siteInfo.dailyReaders}</p>
                  <p className="text-xs text-foreground-400 mt-1">日活读者</p>
                </div>
              </div>

              <a
                href={`mailto:${siteInfo.email}`}
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-2.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors w-fit"
              >
                商务合作 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>

            <div className="w-full lg:w-[45%]">
              <div className="relative rounded-xl overflow-hidden bg-background-100">
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20space%20with%20comic%20art%20on%20walls%2C%20Korean%20manhwa%20illustrations%2C%20warm%20natural%20lighting%2C%20minimal%20interior%20design%2C%20cozy%20reading%20nooks%2C%20editorial%20photography%2C%20professional%20yet%20creative%20atmosphere&width=800&height=600&seq=hanman-about-office&orientation=landscape"
                    alt="韩漫大全办公空间"
                    title="韩漫大全 - 韩国漫画免费阅读平台"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <span className="absolute top-4 left-4 bg-background-50 text-foreground-900 text-xs font-medium px-3 py-1 rounded-full">
                  值得信赖
                </span>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <p className="text-background-50 text-sm font-medium">韩国漫画免费阅读第一站</p>
                  <p className="text-background-50/60 text-xs mt-1">每日更新 · 永久免费</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-foreground-900 py-14 md:py-20">
        <div className="px-4 md:px-6 lg:px-10">
          <div className="flex items-start gap-8 mb-10">
            <span className="whitespace-nowrap cursor-pointer border border-background-50/30 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium">
              平台数据
            </span>
            <h2 className="text-3xl md:text-5xl font-bold font-heading text-background-50 leading-tight">
              韩漫大全<br />实力见证
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {[
              { label: '成立年份', value: siteInfo.established, unit: '年' },
              { label: '收录作品', value: siteInfo.totalComics, unit: '部' },
              { label: '日活读者', value: siteInfo.dailyReaders, unit: '人' },
              { label: '合作伙伴', value: siteInfo.partnerCount, unit: '家' },
            ].map((item, idx) => (
              <div key={idx} className="bg-background-100 rounded-lg px-5 py-6 text-center">
                <p className="text-2xl md:text-3xl font-bold text-foreground-900">
                  {item.value}
                </p>
                <p className="text-xs text-foreground-400 mt-2">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="px-4 md:px-6 lg:px-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-3">
            读者<strong>口碑</strong>
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            来自韩漫爱好者的真实评价
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {reviews.map((review) => (
              <div key={review.id} className="bg-background-50 rounded-lg p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200">
                    <img
                      src={review.avatar}
                      alt={review.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                    <p className="text-xs text-foreground-400">{review.level}</p>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-50 py-14 md:py-20">
        <div className="px-4 md:px-6 lg:px-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-3">
            <strong>联系我们</strong>
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10">
            欢迎通过以下方式与我们取得联系
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="bg-background-100 rounded-lg p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-full flex items-center justify-center">
                <i className="ri-mail-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <p className="text-xs text-foreground-400 mb-1">电子邮箱</p>
              <p className="text-sm font-medium text-foreground-900">{siteInfo.email}</p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-full flex items-center justify-center">
                <i className="ri-phone-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <p className="text-xs text-foreground-400 mb-1">联系电话</p>
              <p className="text-sm font-medium text-foreground-900">{siteInfo.phone}</p>
            </div>
            <div className="bg-background-100 rounded-lg p-6 text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-accent-100 rounded-full flex items-center justify-center">
                <i className="ri-map-pin-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <p className="text-xs text-foreground-400 mb-1">公司地址</p>
              <p className="text-sm font-medium text-foreground-900">{siteInfo.address}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50 pb-14 md:pb-20">
        <div className="px-4 md:px-6 lg:px-10 text-center">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
            合作邀请
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8 max-w-xl mx-auto">
            韩漫大全诚邀漫画出版社、翻译团队、广告合作伙伴加入我们，共同打造更优质的中文韩漫阅读生态
          </p>
          <Link
            to="/"
            className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-primary-500 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            回到首页开始阅读 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>

          <div className="mt-10 flex justify-center gap-6 md:gap-10 flex-wrap">
            {['出版社A', '出版社B', '翻译组A', '翻译组B'].map((name, idx) => (
              <div key={idx} className="px-5 py-3 bg-background-100 rounded-lg">
                <span className="text-sm text-foreground-500 font-medium">{name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}